/**
 * Pump definitions, mirroring the five pumps the old PumpData.js component
 * plotted. Each pump exposes four metrics read straight off the
 * Herrenknecht v3 API: output current, frequency (Drehzahl %), utilisation
 * (Auslastung), and power.
 */

export type PumpId = "feed1" | "feed2" | "slurry1" | "slurry2" | "slurry3";

export type PumpMetric = "current" | "revs" | "utilisation" | "power";

export interface PumpDef {
  id: PumpId;
  displayName: string;
  /** Reference-id prefix, e.g. "V40_P11". The four metrics suffix this. */
  refPrefix: string;
}

export const PUMPS: Record<PumpId, PumpDef> = {
  feed1:   { id: "feed1",   displayName: "Feed pump 1",   refPrefix: "V40_P11" },
  feed2:   { id: "feed2",   displayName: "Feed pump 2",   refPrefix: "V42_P12" },
  slurry1: { id: "slurry1", displayName: "Slurry pump 1", refPrefix: "V41_P21" },
  slurry2: { id: "slurry2", displayName: "Slurry pump 2", refPrefix: "V43_P22" },
  slurry3: { id: "slurry3", displayName: "Slurry pump 3", refPrefix: "V45_P23" },
};

export const PUMP_LIST: PumpDef[] = Object.values(PUMPS);

export interface PumpMetricDef {
  id: PumpMetric;
  /** Reference-id suffix appended to the pump's prefix. */
  suffix: string;
  /** Legend label, matching the old PumpData.js naming. */
  label: string;
  unit: string;
}

export const PUMP_METRICS: Record<PumpMetric, PumpMetricDef> = {
  current:     { id: "current",     suffix: "_Strom_Z", label: "Output Current", unit: "A"  },
  revs:        { id: "revs",        suffix: "_Drehz_Z", label: "Frequency",      unit: "%"  },
  utilisation: { id: "utilisation", suffix: "_Ausl_Z",  label: "Utilisation",    unit: "%"  },
  power:       { id: "power",       suffix: "_Leist_Z", label: "Power",          unit: "kW" },
};

export const PUMP_METRIC_LIST: PumpMetricDef[] = Object.values(PUMP_METRICS);

export function pumpReferenceId(pumpId: PumpId, metric: PumpMetric): string {
  return PUMPS[pumpId].refPrefix + PUMP_METRICS[metric].suffix;
}

/** All pump-related reference ids (5 pumps × 4 metrics = 20). */
export const PUMP_REFERENCE_IDS: string[] = (() => {
  const out: string[] = [];
  for (const pump of PUMP_LIST) {
    for (const metric of PUMP_METRIC_LIST) {
      out.push(pump.refPrefix + metric.suffix);
    }
  }
  return out;
})();
